import en from "./en.json";
import ar from "./ar.json";
import tr from "./tr.json";
import fa from "./fa.json";
import ckb from "./ckb.json"; 

export const dictionaryList = { en, ar, tr, fa, ckb };

export const languageOptions = {
  en: "English",
  ar: "عربى",       
  tr: "Türkçe",     
  fa: "فارسی",  
  ckb: "Sorani",    
};
